import camelCase from 'camelcase';
import decamelize from 'decamelize';

export const isObject = (value: any): boolean =>
  !Array.isArray(value) && typeof value === 'object' && value !== null;

export const isString = (value: any): boolean => typeof value === 'string';

const transformCase = (src: any, caseFn: (str: string) => string): object =>
  isString(src)
    ? caseFn(src)
    : Object.keys(src).reduce(
        (accumulator, currentValue) => ({
          ...accumulator,
          [caseFn(currentValue)]: isObject(src[currentValue])
            ? transformCase(src[currentValue], caseFn)
            : src[currentValue],
        }),
        {}
      );

export const toCamelCase = (src: any): object => transformCase(src, camelCase);

export const toSnakeCase = (src: any): object => transformCase(src, decamelize);
